export enum TrackingEventType {
  Click = 0,
  Success = 1,
  Error = 2,
  View = 3
}
